import * as React from 'react';
import { DogsGeovapModal } from '@modules/dogs/DogsGeovapModal';
import { ModalButton } from '@components/modalButton/ModalButton';

interface EventsFormParticipantsDogsModalProps {
  onSaveDogs: () => void;
  doglust: any;
}

export const EventsFormParticipantsDogsModal: React.FC<EventsFormParticipantsDogsModalProps> = ({
  onSaveDogs,
  doglust
}) => {
  return (
    <>
      {doglust === 'geopa' && (
        <div className="buttons">
          <ModalButton
            label="Zkontrolovat psa"
            ModalComponent={DogsGeovapModal}
            style={{ marginLeft: 5, marginBottom: 10, marginRight: 10 }}
            dialogStyles={{
              style: { paddingTop: '5vh' },
              contentStyle: {
                paddingTop: 10,
                transform: 'none'
              },
              bodyStyle: { padding: '0', overflow: 'auto' }
            }}
            onSave={onSaveDogs}
          />
        </div>
      )}
    </>
  );
};



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormParticipantsDogsModal.tsx